/* eslint-disable */
import React, { Component } from "react";
import InputRange from "react-input-range";
import "./PackagePlan.css";
import "./ActivityListing.css";
import {
  PackageZoneData,
  getTourPackageList,
  getTourFilterPackage,
  getalltransport,
  getTourPackagePlanlist
} from "../Component/axios";
import Autosuggest from "react-autosuggest";
import NewHeader from "../Component/NewHeader/NewHeader";
import moment from "moment";
import {Helmet} from "react-helmet";
// import {
//   RangeDatePicker,
//   SingleDatePicker,
// } from "react-google-flight-datepicker";
import "react-google-flight-datepicker/dist/main.css";

import DayPicker from "react-day-picker";
import "react-day-picker/lib/style.css";
import HotelListSkeleton from "../Component/HostelList/HotelListSkeleton";
import TourPackageList from "../TourList/TourPackageList";
import Slider from "react-slick";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faEuroSign,
} from "@fortawesome/free-solid-svg-icons";
import Skeleton from "react-loading-skeleton";
import CheckboxTree from 'react-checkbox-tree';
import 'react-checkbox-tree/lib/react-checkbox-tree.css';
import  ExperiencesSoldout  from "./SoldOut/ExperiencesSoldout";
import ExperiencesCovid from "./CovidData/ExperiencesCovid";
import TawkToWidget from "../Component/TawkToWidget";
const SortArr = [
  { id: "4", name: "Recommended" },
  { id: "1", name: "Price - Low to High" },
  { id: "2", name: "Price - High to Low" },
];

const Duration = [
  { id: "1", name: "Up to 1 hour" },
  { id: "2", name: "1 to 4 hours" },
  { id: "3", name: "4 hours to 1 day" },
  { id: "4", name: "1 to 3 days" },
  { id: "5", name: "3+ days" },
];

const TimeOfDays = [
  { id: "1", name: "Morning", smallLabel:"Starts before 12 pm" },
  { id: "2", name: "Afternoon", smallLabel:"Starts after 12 pm"  },
  { id: "3", name: "Evening and night", smallLabel:"Starts after 5 pm"  },
];

export default class PackagePlanListing extends Component {
  constructor(props) {
    super(props);
    this.state = {
      startDate: null,
      endDate: null,
      isOpen: false,
      dropdownVisible: false,
      selected: "Accommodations",
      searchInput: "",
      error: null,
      val: "",
      showResults: false,
      SelectedPlace: null,
      nav: false,
      searchData: "",
      sorting: false,
      sortingSelect: "Recommended",
      isDropdownOpen: false,
      sortingId: null,
      value: "",
      suggestionsPackage: [],
      showResultsPackage: false,
      defaultZonevalPackage: "Mahe Island",
      selectPackageDay: moment(new Date()).format("ddd, D MMM yy"),
      selectPackageDayNew: new Date(),
      checkinShowPackage: false,
      packageData: null,
      FiltersData: null,
      valuePrice: { min: 0, max: 10 },
      appliedFilterVal: [],
      checked: false,
      checkedItems: new Map(),
      packageList: null,
      packageListFilter: null,
      checkedTime: false,
      checked: [],
      expanded: [],
      CategotyThem:null
    };
  }

  componentDidMount() {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const defaultZonevalPackageVal = urlParams.get("defaultZonevalPackageVal");
    const dateSelected = urlParams.get("dateSelected");
   
    this.setState({ defaultZonevalPackage: defaultZonevalPackageVal });
    this.setState({ selectPackageDayNew: dateSelected });
    this.setState({
      selectPackageDay: moment(dateSelected).format("ddd, D MMM yy"),
    });
    
    let JsonState = {
      defaultZonevalPackageVal: defaultZonevalPackageVal,
      dateSelected: moment(dateSelected).format("Y-MM-DD"),
    };
    const packageArr = JSON.stringify(JsonState);

    PackageZoneData().then(
      (data) => {
        this.setState({
          itemsZonePackage: data,
        });
      },
      (error) => {
        this.setState({
          error,
        });
      }
    );

    const tour_type= {tour_type:"Package"}
    const tourtype = JSON.stringify(tour_type);
      getalltransport(tourtype).then(
        (data) => {
       
          this.setState({ CategotyThem:data.transport_mode_name});
        },
        (error) => {
          this.setState({
            error,
          });
        }
      );
    
    getTourPackagePlanlist(packageArr).then(
      (data) => {
      
        if (data == undefined) {
          this.setState({
            packageData: null,
          });
        } else {
         
          this.setState({
            packageListFilter: data,
          });

          if (data == "no_package") {
            this.setState({
              packageData: data,
            });
          } else {
            this.SortingFunction(data);
          }
        }
      },
      (error) => {
        this.setState({
          error,
        });
      }
    );
    

    let JsonState1 = {
      defaultZonevalVal: defaultZonevalPackageVal,
      dateSelected: moment(dateSelected).format("Y-MM-DD"),
    };
    const packageArr1 = JSON.stringify(JsonState1);

    getTourFilterPackage(packageArr1).then(
      (data) => {
        if (data?.max_price) {
          this.setState({ FiltersData: data })
          this.setState({ valuePrice: { min: 0, max: data?.max_price.toFixed(2) } })
        } else {
          this.setState({ FiltersData: data })
        }
      },
      (error) => {
        this.setState({
          error,
        });
      }
    );

    window.addEventListener("scroll", this.handleScroll);
  }

  SearchListing = () => {
    this.setState({
      FiltersData: null,
    });
    this.setState({
      packageData: null,
    });
    this.setState({
      sortingSelect: "Recommended",
    });

    let JsonState = {
      defaultZonevalPackageVal: this.state.defaultZonevalPackage,
      dateSelected: moment(this.state.selectPackageDayNew).format("Y-MM-DD"),
    };
    const packageArr = JSON.stringify(JsonState);
  
    PackageZoneData().then(
      (data) => {
        this.setState({
          itemsZonePackage: data,
        });
      },
      (error) => {
        this.setState({
          error,
        });
      }
    );

   

    getTourPackagePlanlist(packageArr).then(
       (data) => {
        if (data == undefined) {
          this.setState({
            packageData: null,
          });
        } else {
          this.setState({
            packageListFilter: data,
          });

          if (data == "no_package") {
            this.setState({
              packageData: data,
            });
          } else {
            this.SortingFunction(data);
          }
        }
      },
      (error) => {
        this.setState({
          error,
        });
      }
    );
    let JsonState1 = {
      defaultZonevalVal: this.state.defaultZonevalPackage,
      dateSelected: moment(this.state.selectPackageDayNew).format("Y-MM-DD"),
    };
    const hotelArr1 = JSON.stringify(JsonState1);

    getTourFilterPackage(hotelArr1).then(
      (data) => {
        if (data?.max_price) {
          this.setState({ FiltersData: data })
          this.setState({ valuePrice: { min: 0, max: data?.max_price.toFixed(2) } })
        } else {
          this.setState({ FiltersData: data })
        }
      },
      (error) => {
        this.setState({
          error,
        });
      }
    );
  };

  SortingFunction = (data) => {
    if (data != "no_package") {
    
      const sorArr = data;
      const zeroElement = sorArr[0];

      setTimeout(() => {
        // const getValue = (price) => +price;
        // sorArr.sort(
        //   (a, b) =>
        //     getValue(
        //       Object.values(a).map((i, j) => {
        //         return i.tour_price;
        //       })
        //     ) -
        //     getValue(
        //       Object.values(b).map((i, j) => {
        //         return i.tour_price;
        //       })
        //     )
        // );

        this.setState({
          packageData: sorArr,
        });
        this.setState({ packageListFilter: sorArr });
      }, 2000);
    }
  };

  sortingSearch = (data) => {
  
    const sorArr = data;
    if (this.state.sortingSelect == "Price - Low to High") {

      setTimeout(() => {
        if (sorArr[0].matched) {
          const sliceArr = sorArr.shift();
          const getValue = (price) => +price;

          sorArr.sort(
            (a, b) =>
              getValue(
                Object.values(a).map((i, j) => {
                  return i.tour_price;
                })
              ) -
              getValue(
                Object.values(b).map((i, j) => {
                  return i.tour_price;
                })
              )
          );

          this.setState({
            packageData: sorArr,
          });

          this.setState({ packageListFilter: sorArr });
        } else {
          const getValue = (price) => +price;
          sorArr.sort(
            (a, b) =>
              getValue(
                Object.values(a).map((i, j) => {
                  return i.tour_price;
                })
              ) -
              getValue(
                Object.values(b).map((i, j) => {
                  return i.tour_price;
                })
              )
          );

        

          this.setState({
            packageData: sorArr,
          });
          this.setState({ packageListFilter: sorArr });
        }
      }, 2000);
    } else if (this.state.sortingSelect == "Price - High to Low") {
      setTimeout(() => {
        const getValue = (price) => -price;

        sorArr.sort(
          (a, b) =>
            getValue(
              Object.values(a).map((i, j) => {
                return i.tour_price;
              })
            ) -
            getValue(
              Object.values(b).map((i, j) => {
                return i.tour_price;
              })
            )
        );

        this.setState({
          packageData: sorArr,
        });
        this.setState({ packageListFilter: sorArr });
      }, 1000);
    } else if (this.state.sortingSelect == "Recommended") {
      setTimeout(() => {

        const getValue = (price) => price;

        sorArr.sort(
          (a, b) =>
            getValue(
              Object.values(a).map((i, j) => {
                return i.tour_price;
              })
            ) -
            getValue(
              Object.values(b).map((i, j) => {
                return i.tour_price;
              })
            )
        );
        this.setState({
          activityData: sorArr,
        });
        this.setState({ packageListFilter: sorArr });
      }, 1000);
    }
  };

  componentWillUnmount() {
    // document.removeEventListener('click', this.globalClickListener)
    window.removeEventListener("click", this.globalClickListener);
    window.removeEventListener("scroll", this.handleScroll);
  }
  globalClickListener = (nativeEvent) => {
    this.setState(
      {
        isDropdownOpen: false,
        dropdownVisible: false,
        showResultsPackage: false,
        checkinShowPackage: false,
      },
      () => {
     
        // document.removeEventListener('click', this.globalClickListener)
        window.removeEventListener("click", this.globalClickListener);
      }
    );
  };

  checkinandcheckoutPackage = (syntheticEvent) => {
    this.setState({ showResultsPackage: false });
    syntheticEvent.stopPropagation();
    this.setState(
      (prevState) => ({ checkinShowPackage: !prevState.checkinShowPackage }),
      () => {
        if (this.state.checkinShowPackage) {
       
          window.addEventListener("click", this.globalClickListener);
        }
      }
    );
    
  };

  handleBodyClick = (event) => {
    event.stopPropagation();
  };

  showSorting = (syntheticEvent) => {
  
    syntheticEvent.stopPropagation();
    this.setState((prevState) => ({
      isDropdownOpen: !prevState.isDropdownOpen,
    }));
    this.setState(
      (prevState) => ({ sorting: !prevState.sorting }),
      () => {
        if (this.state.sorting) {
        
          // document.addEventListener('click', this.globalClickListener)
          window.addEventListener("click", this.globalClickListener);
        }
      }
    );
  };
  getSuggestionsPackage = (value) => {
    const inputValue = value.trim().toLowerCase();
    const inputLength = inputValue.length;

    return inputLength === 0
      ? []
      : this.state.itemsZonePackage.filter(
          (lang) => lang.Name.toLowerCase().slice(0, inputLength) === inputValue
        );
  };

  onSuggestionsFetchRequestedPackage = ({ value }) => {
    this.setState({
      suggestionsPackage: this.getSuggestionsPackage(value),
    });
  };

  // Autosuggest will call this function every time you need to clear suggestions.
  onSuggestionsClearRequestedPackage = () => {
    this.setState({
      suggestionsPackage: [],
    });
  };

  onSuggestionSelectedPackage = () => {
    this.setState({
      showResultsPackage: false,
    });
  };

  getSuggestionValuePackage = (suggestion) => suggestion.Name;

  // Use your imagination to render suggestions.
  getSuggestionValuePackage = (suggestion) => suggestion.Name;

  // Use your imagination to render suggestions.
  renderSuggestionPackage = (suggestion, { query, isHighlighted }) => (
    <div className="font14 darkText  noChild  clickable">
      <div className="hsFlexspaceBetween hsFlex hrtlCenter ">
        {suggestion.LocationImage != "nolocation" ? (
          <div className="locationImageLocation">
          <img
          src="images/locationacco.png"
          className="locationImageContent"
          />
        </div>
        ) : (
          <div className="tourImage">
            {" "}
            <img src={suggestion.Image} className="locationImageContent2" />
          </div>
        )}
        <div className="flexOne">
          <p className="locusLabel appendBottom5 fontSizeChange">
            {suggestion.Name}
          </p>
        </div>
      </div>
    </div>
  );

  renderSuggestionsContainerPackage = ({ containerProps, children, query }) => {
    return (
      <div {...containerProps}>
        <div class="react-autosuggest__section-title">
          <label class="hsw_sectionTitle font12 latoBlack greyText">
          Suggestions{" "}
          </label>
        </div>
        {/* <div> {children}</div> */}
        {query.length === 0 ? (
            <div>
                {/* <p class="hsw_sectionTitle font12 latoBlack greyText">Popular</p> */}
        <ul role="listbox" class="react-autosuggest__suggestions-list">
        {/* <li
            role="option"
            id="react-autowhatever-1-section-1-item-0"
            aria-selected="false"
            class="react-autosuggest__suggestion react-autosuggest__suggestion--first"
            data-section-index="1"
            data-suggestion-index="0"
          >
            <div className="font14 darkText  noChild  clickable" onClick={() => this.handleChangeSuggetionPackage("Seychelles")}>
                <div className="hsFlexspaceBetween hsFlex hrtlCenter ">
                
                <div className="locationImageLocation">
                    <img
                    src="images/locationacco.png"
                    className="locationImageContent"
                    />
                </div>
                
                    <div className="flexOne">
                    <p className="locusLabel appendBottom5 fontSizeChange">
                    Seychelles
                    </p>
                    </div>
                    </div>
            </div>
          </li> */}
          <li
            role="option"
            id="react-autowhatever-1-section-1-item-0"
            aria-selected="false"
            class="react-autosuggest__suggestion react-autosuggest__suggestion--first"
            data-section-index="1"
            data-suggestion-index="0"
          >
            <div className="font14 darkText  noChild  clickable" onClick={() => this.handleChangeSuggetionPackage("Mahe Island")}>
                <div className="hsFlexspaceBetween hsFlex hrtlCenter ">
                
                <div className="locationImageLocation">
                    <img
                    src="images/locationacco.png"
                    className="locationImageContent"
                    />
                </div>
                
                    <div className="flexOne">
                    <p className="locusLabel appendBottom5 fontSizeChange">
                    Mahe Island
                    </p>
                    </div>
                    </div>
            </div>
          </li>
          <li
            role="option"
            id="react-autowhatever-1-section-1-item-0"
            aria-selected="false"
            class="react-autosuggest__suggestion react-autosuggest__suggestion--first"
            data-section-index="1"
            data-suggestion-index="0"
          >
            <div className="font14 darkText  noChild  clickable" onClick={() => this.handleChangeSuggetionPackage("Praslin Island")}>
      <div className="hsFlexspaceBetween hsFlex hrtlCenter ">
      
            <div className="locationImageLocation">
                <img
                src="images/locationacco.png"
                className="locationImageContent"
                />
            </div>
       
        <div className="flexOne">
          <p className="locusLabel appendBottom5 fontSizeChange">
          Praslin Island
          </p>
        </div>
      </div>
      </div>
          </li>
          <li
            role="option"
            id="react-autowhatever-1-section-1-item-0"
            aria-selected="false"
            class="react-autosuggest__suggestion react-autosuggest__suggestion--first"
            data-section-index="1"
            data-suggestion-index="0"
          >
            <div className="font14 darkText  noChild  clickable" onClick={() => this.handleChangeSuggetionPackage("La Digue Island")}>
      <div className="hsFlexspaceBetween hsFlex hrtlCenter ">
      
        <div className="locationImageLocation">
            <img
            src="images/locationacco.png"
            className="locationImageContent"
            />
        </div>
       
        <div className="flexOne">
          <p className="locusLabel appendBottom5 fontSizeChange">
          La Digue Island
          </p>
        </div>
      </div>
    </div>
          </li>
          
        </ul></div>
         ) : (
            <div> {children}</div>
          )}
      </div>
    );
  };

  showZonelistdivPackage = (syntheticEvent) => {
    this.setState({ checkinShowPackage: false });
    syntheticEvent.stopPropagation();
    this.setState(
      (prevState) => ({ showResultsPackage: !prevState.showResultsPackage }),
      () => {
        if (this.state.showResultsPackage) {
         
          // document.addEventListener('click', this.globalClickListener)
          window.addEventListener("click", this.globalClickListener);
        }
      }
    );
  };

  onChangePackage = (event, { newValue }) => {
    this.setState({
      value: newValue,
      defaultZonevalPackage: newValue,
    });
  };

  handleChangeSuggetionPackage = (newValue) => {
    this.setState({
      value: newValue,
      defaultZonevalPackage: newValue,
    });
    this.setState({
        showResultsActivity: false,
      });
  };
  handlePackageDayClick = (day, { selected, disabled }) => {
    if (disabled) {
      // If the day is disabled, do nothing
      return;
    }
    this.setState({ selectPackageDayNew: selected ? undefined : day });
    this.setState({ selectPackageDay: moment(day).format("ddd, D MMM yy") });
    this.setState({ checkinShowPackage: false });
  };

  handleScroll = () => {
    if (window.pageYOffset > 10) {
      if (!this.state.nav) {
        this.setState({ nav: true });
      }
    } else {
      if (this.state.nav) {
        this.setState({ nav: false });
      }
    }
  };

  handleSortingChange = (e) => {
    this.setState({ isDropdownOpen: false });
    this.setState({
      packageData: null,
    });

    const sorArr = this.state.packageData;
  
    if (e.id == 2) {
      setTimeout(() => {
        const getValue = (price) => -price;

        sorArr.sort(
          (a, b) =>
            getValue(
              Object.values(a).map((i, j) => {
                return i.tour_price;
              })
            ) -
            getValue(
              Object.values(b).map((i, j) => {
                return i.tour_price;
              })
            )
        );

  
        this.setState({
          packageData: sorArr,
        });
      }, 1000);
    } else if (e.id == 3) {
      setTimeout(() => {
        const getValue = (star) => -star;
        sorArr.sort((a, b) => getValue() - getValue());

        this.setState({
          packageData: sorArr,
        });
      }, 1000);
    } else if (e.id == 1) {
      setTimeout(() => {
        const getValue = (price) => +price;
        sorArr.sort(
          (a, b) =>
            getValue(
              Object.values(a).map((i, j) => {
                return i.tour_price;
              })
            ) -
            getValue(
              Object.values(b).map((i, j) => {
                return i.tour_price;
              })
            )
        );

        this.setState({
          packageData: sorArr,
        });
      }, 1000);
    } else if (e.id == 4) {
      setTimeout(() => {
        const getValue = (id) => id;
        sorArr.sort(
          (a, b) =>
            getValue(
              Object.values(a).map((i, j) => {
                return i.tour_data.id;
              })
            ) -
            getValue(
              Object.values(b).map((i, j) => {
                return i.tour_data.id;
              })
            )
        );


        this.setState({
          packageData: sorArr,
        });
        // this.setState({
        //   SkeletonData: false,
        // });
      }, 1000);
    }

    this.setState({
      sortingSelect: e.name,
    });

    this.setState({
      sortingId: e.id,
    });
  };

  CheckAppliedFilterLocation = () => {
  
    this.setState({ packageData: null });

    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    
    const name = target.name;
    let applied = [...this.state.appliedFilterVal];

    const isChecked = event.target.checked;

    if (value) {
      this.setState({
        appliedFilterVal: [...applied, { label: name, value: value }],
      });
    } else {
      const name = target.name;
      let applied = [...this.state.appliedFilterVal];
      const index = applied.findIndex((x) => x.label == name);
      // Remove the filter if it exists
      applied.splice(index, 1);
      this.setState({
        appliedFilterVal: applied,
      });
    }
    // this.setState({checked: value});
    this.setState((prevState) => ({
      checkedItems: prevState.checkedItems.set(name, isChecked),
    }));

    const packagedData = [...this.state.packageListFilter];

    const result = [];

  setTimeout(() => {
    packagedData && packagedData.map((i, j) => {
      if (i != "no_package") {
          Object.values(i).map((key1, index) => {
              if(this.state.appliedFilterVal.length> 0){
              this.state.appliedFilterVal.map((item, index) => {
                 
                  if(this.state.defaultZonevalPackage.toLowerCase().trim() === 'seychelles'){
                    if(key1.tour_data.tour_region_name.toLowerCase().trim() === item.label) {
                      result.push(i);
                    }
                  }else{
                    if(key1.tour_data.tour_location.toLowerCase().trim() === item.label){
                      result.push(i);
                    }
                  }
                });
            }
          });
        }
      });
  }, 1000); 
 
    setTimeout(() => {
      this.setState({ packageData: result });
    }, 1000);

    setTimeout(() => {
      if (this.state.appliedFilterVal.length == 0) {
        this.setState({ packageData: packagedData });
      }
    }, 1000);
  };
  CheckAppliedFilterCategory = (nodecheck) => {

    this.setState({checked : nodecheck})
    this.setState({ packageData: null });
    this.setState({
      SkeletonData: true,
    });

    
 const packageData =  [...this.state.packageListFilter];
if(nodecheck.length){
 
const result = [];
      packageData && packageData.map((i, j) => {
        if (i != "no_package") {
          Object.values(i).map((key1, index) => {
            if (nodecheck.length > 0) {
             nodecheck.map((item, index) => {
                  if (key1.tour_data.transport_mode_name.toLowerCase().trim() === item) {
                    result.push(i);
                  }
             
              });
            }
          });
        }
      });
 
    setTimeout(() => {
             this.setState({ packageData: result });
            this.setState({
              SkeletonData: false,
            });
          }, 1000);
}else{
      setTimeout(() => {
      if (this.state.appliedFilterVal.length == 0) {
        this.setState({ packageData: packageData });
        this.setState({
          SkeletonData: false,
        });
      }
    }, 1000);
}

  };


  
  CheckAppliedFilter = () => {
   
    this.setState({ packageData: null });

    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
  
    const name = target.name;
    let applied = [...this.state.appliedFilterVal];

    const isChecked = event.target.checked;

    if (value) {
      this.setState({
        appliedFilterVal: [...applied, { label: name, value: value }],
      });
    } else {
      const name = target.name;
      let applied = [...this.state.appliedFilterVal];
      const index = applied.findIndex((x) => x.label == name);
      // Remove the filter if it exists
      applied.splice(index, 1);
      this.setState({
        appliedFilterVal: applied,
      });
    }
    // this.setState({checked: value});
    this.setState((prevState) => ({
      checkedItems: prevState.checkedItems.set(name, isChecked),
    }));

    const packageData = [...this.state.packageListFilter];

    const result = [];

    setTimeout(() => {
      packageData.map((i, j) => {
        if (i != 'no_package') {
          Object.values(i).map((key1, index) => {
            if (this.state.appliedFilterVal.length > 0) {
              this.state.appliedFilterVal.map((item, index) => {
                let Minhours = 0;
                let Maxhours = 0;
                if(key1.tour_duration.flexible_id ==1){
                  if(key1.tour_duration.flexible_time ==2){
                  Minhours = parseInt(key1.tour_duration.flexible_min_hours);
                  Maxhours = parseInt(key1.tour_duration.flexible_max_hours);
                  }else{
                     Minhours = (parseInt(key1.tour_duration.flexible_min_hours)/60);
                    Maxhours = (parseInt(key1.tour_duration.flexible_max_hours)/60);
                  }
                }else{
                  Minhours = parseInt(key1.tour_duration.flexible_min_hours); 
                  Maxhours = parseInt(key1.tour_duration.flexible_max_hours); 
                }
                if (item.label == "Up to 1 hour") {
                  const minvalue = 0;
                  const maxvalue = 1;
                  if (
                    Minhours >= minvalue &&
                    Maxhours <= maxvalue
                  ) {
                    result.push(i);
                  }
                
                } else if (item.label == "1 to 4 hours") {
                  const minvalue = 1;
                  const maxvalue = 4;
                  if (
                    Minhours >= minvalue &&
                    Maxhours <= maxvalue
                  ) {
                    result.push(i);
                  }
                } else if (item.label == "4 hours to 1 day") {
                  const minvalue = 4;
                  const maxvalue = 24;
                  if (
                    Minhours >= minvalue &&
                    Maxhours <= maxvalue
                  ) {
                    result.push(i);
                  }
                } else if (item.label == "1 to 3 days") {
                  const mindays = 1;
                  const maxdays = 3;
                  if (
                    parseInt(key1.tour_duration.day_number) >= mindays &&
                    parseInt(key1.tour_duration.day_number) <= maxdays
                  ) {
                    result.push(i);
                  }
                } else if (item.label == "3+ days") {
                  const mindays = 3;

                  if (
                    parseInt(key1.tour_duration.day_number) >= mindays &&
                    parseInt(key1.tour_duration.day_number) < mindays
                  ) {
                    result.push(i);
                  }
                }
              });
            } else {
              result.push(i);
            }
          });

        }

      });
    }, 1000);

    setTimeout(() => {
      this.setState({ packageData: result });
    }, 1000);

    setTimeout(() => {
      if (this.state.appliedFilterVal.length == 0) {
        this.setState({ packageData: packageData });
      }
    }, 1000);
  };


  //Time Data

 
  CheckTimeOfDaysFilter = () => {
   
    this.setState({ packageData: null });
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    
    const name = target.name;
    let applied = [...this.state.appliedFilterVal];

    const isChecked = event.target.checked;

    if (value) {
      this.setState({
        appliedFilterVal: [...applied, { label: name, value: value }],
      });
    } else {
        const name = target.name;
        let applied = [...this.state.appliedFilterVal];
        const index = applied.findIndex((x) => x.label === name);
        // Remove the filter if it exists
        applied.splice(index, 1);
        this.setState({
          appliedFilterVal: applied,
        });
    }
    // this.setState({checked: value});
    this.setState((prevState) => ({
      checkedItems: prevState.checkedItems.set(name, isChecked),
    }));

    const packageData = [...this.state.packageListFilter];

    const result = [];

    setTimeout(() => {
      packageData.map((i, j) => {
        {
          Object.values(i).map((key1, index) => {
            let checkTime = false;
            if (key1.tour_time) {
              key1.tour_time.map((key2, index) => {
                if (this.state.appliedFilterVal.length > 0) {
                  this.state.appliedFilterVal.map((item, index) => {
                    if (item.label == "Morning") {
                      const from_time = "05:59 am";
                      const lost_time = "12:01 pm";
                      const maxvalue = 1;
                      var dt1 = moment(from_time, ["h:mm A"]).format("HH:mm");
                      var dt2 = moment(key2.from_time, ["h:mm A"]).format(
                        "HH:mm"
                      );
                      var dt3 = moment(lost_time, ["h:mm A"]).format("HH:mm");

                      const startTime = dt1; //'01/01/2011 10:20:45';
                      const endTime = dt2; //'01/01/2011 5:10:10';
                      var regExp = /(\d{1,2})\:(\d{1,2})\:(\d{1,2})/;
                      if (
                        parseInt(endTime.replace(regExp, "$1$2$3")) >
                          parseInt(startTime.replace(regExp, "$1$2$3")) &&
                        parseInt(endTime.replace(regExp, "$1$2$3")) <
                          parseInt(dt3.replace(regExp, "$1$2$3"))
                      ) {
                        checkTime = true;
                        return checkTime;
                      }
                    } else if (item.label == "Afternoon") {
                      const from_time = "12:01 pm";
                      const lost_time = "05:00 pm";
                      const maxvalue = 1;
                      var dt1 = moment(from_time, ["h:mm A"]).format("HH:mm");
                      var dt2 = moment(key2.from_time, ["h:mm A"]).format(
                        "HH:mm"
                      );
                      var dt3 = moment(lost_time, ["h:mm A"]).format("HH:mm");

                      const startTime = dt1; //'01/01/2011 10:20:45';
                      const endTime = dt2; //'01/01/2011 5:10:10';
                      var regExp = /(\d{1,2})\:(\d{1,2})\:(\d{1,2})/;
                      if (
                        parseInt(endTime.replace(regExp, "$1$2$3")) >
                          parseInt(startTime.replace(regExp, "$1$2$3")) &&
                        parseInt(endTime.replace(regExp, "$1$2$3")) <
                          parseInt(dt3.replace(regExp, "$1$2$3"))
                      ) {
                        checkTime = true;
                        return checkTime;
                      }
                    } else if (item.label == "Evening and night") {
                      const from_time = "05:01 pm";
                      const lost_time = "12:01 am";
                      const maxvalue = 1;
                      var dt1 = moment(from_time, ["h:mm A"]).format("HH:mm");
                      var dt2 = moment(key2.from_time, ["h:mm A"]).format(
                        "HH:mm"
                      );
                      var dt3 = moment(lost_time, ["h:mm A"]).format("HH:mm");

                      const startTime = dt1; //'01/01/2011 10:20:45';
                      const endTime = dt2; //'01/01/2011 5:10:10';
                      var regExp = /(\d{1,2})\:(\d{1,2})\:(\d{1,2})/;
                      if (
                        parseInt(endTime.replace(regExp, "$1$2$3")) >
                          parseInt(startTime.replace(regExp, "$1$2$3")) &&
                        parseInt(endTime.replace(regExp, "$1$2$3")) <
                          parseInt(dt3.replace(regExp, "$1$2$3"))
                      ) {
                        checkTime = true;
                        return checkTime;
                      }
                    }
                  });
                }
              });
            }


            if (checkTime) {
              result.push(i);
            }
          });
        }
      });
    }, 1000);

   
    setTimeout(() => {
      this.setState({ packageData: result });
    }, 1000);

    setTimeout(() => {
      if (this.state.appliedFilterVal.length == 0) {
        this.setState({ packageData: packageData });
      }
    }, 1000);
  };


  changePrice = (value) => {
    this.setState({ packageData: null });
  
    let name = value.min + "-" + value.max;
    let applied = [...this.state.appliedFilterVal];

    let catlength = applied.length;
    let PriceRangeVal = "abc";
   
    applied.map((i, j) => {
      if (i.value == "priceRange") {
        PriceRangeVal = j;
        return PriceRangeVal;
      }
    });

 
    if (PriceRangeVal == "abc") {
      this.setState({
        appliedFilterVal: [...applied, { label: name, value: "priceRange" }],
      });
    } else {
      applied[PriceRangeVal] = { label: name, value: "priceRange" };
      this.setState({
        appliedFilterVal: applied,
      });
    }

    const packagedData = [...this.state.packageListFilter];

    const result = [];

    packagedData.map((i, j) => {
      {
        Object.values(i).map((key1, index) => {
        
          if (
            parseInt(key1.tour_price) >= value.min &&
            parseInt(key1.tour_price) <= value.max
          ) {
            result.push(i);
          }
        });
      }
    });

  
    setTimeout(() => {
      this.setState({ packageData: result });
    }, 1000);
  };

  RemoveSingleFilter = (i, index, maxValue) => {
  
    this.setState({ packageData: null });

    let applied = [...this.state.appliedFilterVal];

    applied.splice(index, 1);

    this.setState({
      appliedFilterVal: applied,
    });

    document.getElementsByName(i.label).checked = false;

    this.setState((prevState) => prevState.checkedItems.set(i.label, false));

    let PriceRange = { min: 0, max: maxValue };

    this.setState({ valuePrice: PriceRange });

    const packagedData = [...this.state.packageListFilter];

    const result = [];

   
    setTimeout(() => {
      packagedData && packagedData.map((i, j) => {
        if (i != "no_package") {
            Object.values(i).map((key1, index) => {
                if(this.state.appliedFilterVal.length> 0){
                this.state.appliedFilterVal.map((item, index) => {
                   
                    if(this.state.defaultZonevalPackage.toLowerCase().trim() === 'seychelles'){
                      if(key1.tour_data.tour_region_name.toLowerCase().trim() === item.label) {
                        result.push(i);
                      }
                    }else{
                      if(key1.tour_data.tour_location.toLowerCase().trim() === item.label){
                        result.push(i);
                      }
                    }
                  });
              }
            });
          }
        });
    }, 1000); 
      

    setTimeout(() => {
      packagedData.map((i, j) => {
        Object.values(i).map((key1, index) => {
          let checkTime = false;
          // Duration Data Filter
          if (this.state.appliedFilterVal.length > 0) {
            this.state.appliedFilterVal.map((item, index) => {
              let Minhours = 0;
              let Maxhours = 0;
              if(key1.tour_duration.flexible_id ==1){
                if(key1.tour_duration.flexible_time ==2){
                Minhours = parseInt(key1.tour_duration.flexible_min_hours);
                Maxhours = parseInt(key1.tour_duration.flexible_max_hours);
                }else{
                   Minhours = (parseInt(key1.tour_duration.flexible_min_hours)/60);
                  Maxhours = (parseInt(key1.tour_duration.flexible_max_hours)/60);
                }
              }else{
                Minhours = parseInt(key1.tour_duration.flexible_min_hours); 
                Maxhours = parseInt(key1.tour_duration.flexible_max_hours); 
              }
              if (item.label == "Up to 1 hour") {
                const minvalue = 0;
                const maxvalue = 1;
                if (
                  Minhours >= minvalue &&
                  Maxhours <= maxvalue
                ) {
                  result.push(i);
                }
              
              } else if (item.label == "1 to 4 hours") {
                const minvalue = 1;
                const maxvalue = 4;
                if (
                  Minhours >= minvalue &&
                  Maxhours <= maxvalue
                ) {
                  result.push(i);
                }
              } else if (item.label == "4 hours to 1 day") {
                const minvalue = 4;
                const maxvalue = 24;
                if (
                  Minhours >= minvalue &&
                  Maxhours <= maxvalue
                ) {
                  result.push(i);
                }
              } else if (item.label == "1 to 3 days") {
                const mindays = 1;
                const maxdays = 3;
                if (
                  parseInt(key1.tour_duration.day_number) >= mindays &&
                  parseInt(key1.tour_duration.day_number) <= maxdays
                ) {
                  result.push(i);
                }
              } else if (item.label == "3+ days") {
                const mindays = 3;

                if (
                  parseInt(key1.tour_duration.day_number) >= mindays &&
                  parseInt(key1.tour_duration.day_number) < mindays
                ) {
                  result.push(i);
                }
              }
            });
          } else {
            result.push(i);
          }
        });
      });
    }, 1000);

    setTimeout(() => {
      packagedData.map((i, j) => {
        {
          Object.values(i).map((key1, index) => {
            let checkTime = false;
           
            key1.tour_time.map((key2, index) => {
              if (this.state.appliedFilterVal.length > 0) {
                this.state.appliedFilterVal.map((item, index) => {
                  if (item.label == "Morning") {
                    const from_time = "05:59 am";
                    const lost_time = "12:01 pm";
                    const maxvalue = 1;
                    var dt1 = moment(from_time, ["h:mm A"]).format("HH:mm");
                    var dt2 = moment(key2.from_time, ["h:mm A"]).format(
                      "HH:mm"
                    );
                    var dt3 = moment(lost_time, ["h:mm A"]).format("HH:mm");

                    const startTime = dt1; //'01/01/2011 10:20:45';
                    const endTime = dt2; //'01/01/2011 5:10:10';
                    var regExp = /(\d{1,2})\:(\d{1,2})\:(\d{1,2})/;
                    if (
                      parseInt(endTime.replace(regExp, "$1$2$3")) >
                        parseInt(startTime.replace(regExp, "$1$2$3")) &&
                      parseInt(endTime.replace(regExp, "$1$2$3")) <
                        parseInt(dt3.replace(regExp, "$1$2$3"))
                    ) {
                      checkTime = true;
                      return checkTime;
                    }
                  } else if (item.label == "Afternoon") {
                    const from_time = "12:01 pm";
                    const lost_time = "05:00 pm";
                    const maxvalue = 1;
                    var dt1 = moment(from_time, ["h:mm A"]).format("HH:mm");
                    var dt2 = moment(key2.from_time, ["h:mm A"]).format(
                      "HH:mm"
                    );
                    var dt3 = moment(lost_time, ["h:mm A"]).format("HH:mm");

                    const startTime = dt1; //'01/01/2011 10:20:45';
                    const endTime = dt2; //'01/01/2011 5:10:10';
                    var regExp = /(\d{1,2})\:(\d{1,2})\:(\d{1,2})/;
                    if (
                      parseInt(endTime.replace(regExp, "$1$2$3")) >
                        parseInt(startTime.replace(regExp, "$1$2$3")) &&
                      parseInt(endTime.replace(regExp, "$1$2$3")) <
                        parseInt(dt3.replace(regExp, "$1$2$3"))
                    ) {
                      checkTime = true;
                      return checkTime;
                    }
                  } else if (item.label == "Evening and night") {
                    const from_time = "05:01 pm";
                    const lost_time = "12:01 am";
                    const maxvalue = 1;
                    var dt1 = moment(from_time, ["h:mm A"]).format("HH:mm");
                    var dt2 = moment(key2.from_time, ["h:mm A"]).format(
                      "HH:mm"
                    );
                    var dt3 = moment(lost_time, ["h:mm A"]).format("HH:mm");

                    const startTime = dt1; //'01/01/2011 10:20:45';
                    const endTime = dt2; //'01/01/2011 5:10:10';
                    var regExp = /(\d{1,2})\:(\d{1,2})\:(\d{1,2})/;
                    if (
                      parseInt(endTime.replace(regExp, "$1$2$3")) >
                        parseInt(startTime.replace(regExp, "$1$2$3")) &&
                      parseInt(endTime.replace(regExp, "$1$2$3")) <
                        parseInt(dt3.replace(regExp, "$1$2$3"))
                    ) {
                      checkTime = true;
                      return checkTime;
                    }
                  }
                });
              }
            });

            if (checkTime) {
              result.push(i);
            }
          });
        }
      });
    }, 1000);

   
    setTimeout(() => {
      this.setState({ packageData: result });
    }, 1000);

    setTimeout(() => {
      if (this.state.appliedFilterVal.length == 0) {
        this.setState({ packageData: packagedData });
      }
    }, 1000);
  };

  RemoveMultipleFilter = (maxValue) => {
    this.setState({ packageData: null });
    this.setState({
      appliedFilterVal: [],
    });
    this.setState({ liveaboardList: null });
    let PriceRange = { min: 0, max: maxValue };

    this.setState({ valuePrice: PriceRange });

    const clearCheckedItems = new Map();
    this.setState({ checkedItems: clearCheckedItems });

    const packagedData = [...this.state.packageListFilter];

    setTimeout(() => {
      this.setState({ packageData: packagedData });
    }, 1000);
  };

 render() {
  
     const menuClass = `panel-dropdown${
       this.state.dropdownVisible ? " active" : ""
     }`;
     const { value, suggestionsPackage } = this.state;
 
     const inputPropsPackage = {
       placeholder: "Enter location or package name",
       type: "search",
       value,
       onChange: this.onChangePackage,
     };
     return (
       <React.Fragment>
    <div className="Detail-container">
      <Helmet>
        <title>Book Best Hotels in seychelles- Holidays Seychelles</title>
        <meta
          name="description"
          content="Book best hotels in Seychelles at affordable prices."
        />
        <meta
          name="keywords"
          content="Seychelles, Seychellen, best place for honeymoon,most beautiful places in the world,best honeymoon destination in the world,honeymoon places,honeymoon destinations,beautiful places in the world"
        />
      </Helmet>
      <h1 style={{ color: "#fff" }}>
        Book Best Hotels in seychelles- Holidays Seychelles
      </h1>
      <NewHeader page={"inner"} />
      <div
                 className={`${
                   this.state.nav == true
                     ? "_Hlisting_header_new"
                     : "_Hlisting_header"
                 }`}
                 makeFlex spaceBetween hrtlCenter listing-modifysearch_wrapper
               >
                 <div className="container hsw">
                   <div className="hsw_inner">
                     <div
                       className="hsw_inputBoxActivity  "
                       onClick={this.showZonelistdivPackage}
                     >
                       <label
                         for="city"
                         className="lbl_input latoBold font12 blueText"
                       >
                      Location 
                       </label>
                       <p
                         className="hsw_inputField font16 whiteText"
                         style={{ marginBottom: "3px" }}
                       >
                         {this.state.defaultZonevalPackage.length >= 50
                           ? `${this.state.defaultZonevalPackage.substring(
                               0,
                               50
                             )}...`
                           : this.state.defaultZonevalPackage}
                       </p>
                       <div className="focused_div">
                         {this.state.showResultsPackage ? (
                           <div
                             className="autocomplete-wrapper"
                             style={{ top: 30 }}
                             onClick={this.handleBodyClick}
                           >
                             <Autosuggest
                               suggestions={suggestionsPackage}
                               onSuggestionsFetchRequested={
                                 this.onSuggestionsFetchRequestedPackage
                               }
                               onSuggestionSelected={
                                 this.onSuggestionSelectedPackage
                               }
                               onSuggestionsClearRequested={
                                 this.onSuggestionsClearRequestedPackage
                               }
                               getSuggestionValue={this.getSuggestionValuePackage}
                               renderSuggestionsContainer={
                                 this.renderSuggestionsContainerPackage
                               }
                               renderSuggestion={this.renderSuggestionPackage}
                               inputProps={inputPropsPackage}
                             />
                           </div>
                         ) : null}
                       </div>
                     </div>
                     <div
                       className="hsw_inputBoxActivity"
                       onClick={this.checkinandcheckoutPackage}
                     >
                       <span className="checkinandcheckout">
                         <label
                           for="checkin"
                           className="lbl_input latoBold font12 blueText capText"
                         >
                           Add when you want to go
                         </label>
                       </span>
                       <p className="hsw_inputField font16 whiteText">
                         {this.state.selectPackageDay}
                       </p>
                       <div onClick={this.handleBodyClick}>
                         {this.state.checkinShowPackage && (
                           <DayPicker
                             className="activityDate"
                             onDayClick={this.handlePackageDayClick}
                             selectedDays={this.state.selectPackageDayNew}
                             disabledDays={{ before: new Date() }}
                             month={new Date()} // Ensure the current month is displayed initially
                             fromMonth={new Date()} // Disable navigation to months before today
                           />
                         )}
                       </div>
                     </div>
                     <span
                       className="primaryBtn hsw_searchButton"
                       onClick={this.SearchListing}
                     >
                       Search
                     </span>
                   </div>
                 </div>
               </div>

               <div className="spaceBetween">
               <div class="scrollBg"></div>
                <div className="listingBannerimg listingHeaderImage">
              <div className="listingBannerDetails">
                <div className="listingHeadingSection">
                  <div className="listingHeading">
                    <h1>{this.state?.defaultZonevalPackage} Packages</h1>
                    <p>Experience beaches and sunset</p>
                  </div>
                </div>
              </div>
            </div>

             {/* Start Body Data */}
             <div className="holidayBody">
              <div className="holidayContainer listingWrap  ">
                <div className="holidayRhs">
                  <ul className="filtersMobSec">
                    <li className="">
                      <span>Filters</span>
                      <span className="icon mmt-filter"></span>
                    </li>
                  </ul>
                  <div className="tabStickyWrapper">
                    <div className="tabScrollSection" id="collectionList">
                      <span className="srollTapLeft ">
                        <span className="icon mmt-chevron-left"></span>
                      </span>
                      <ul className="tabsWrapper">
                        <li className="active ">
                          <span className="name">Best Sellers</span>
                          <span className="packCount">&nbsp;(15)</span>
                        </li>
                        <li className=" ">
                          <span className="name">Honeymoon</span>
                          <span className="packCount">&nbsp;(5)</span>
                        </li>
                        <li className=" ">
                          <span className="name">Goa Escapes</span>
                          <span className="packCount">&nbsp;(53)</span>
                        </li>
                        <li className=" ">
                          <span className="name">Xpress Holidays</span>
                          <span className="packCount">&nbsp;(2)</span>
                        </li>
                        <li className=" ">
                          <span className="name">Beachfront Bliss</span>
                          <span className="packCount">&nbsp;(3)</span>
                        </li>
                        <li className=" ">
                          <span className="name">Villas &amp; More</span>
                          <span className="packCount">&nbsp;(7)</span>
                        </li>
                        <li className=" ">
                          <span className="name">Premium Stays</span>
                          <span className="packCount">&nbsp;(8)</span>
                        </li>
                        <li className=" ">
                          <span className="name">
                            Two Stays for Twice the Fun
                          </span>
                          <span className="packCount">&nbsp;(5)</span>
                        </li>
                        <li className=" ">
                          <span className="name">In &amp; Around Goa</span>
                          <span className="packCount">&nbsp;(2)</span>
                        </li>
                      </ul>
                      <span className="srollTapRight ">
                        <span className="icon mmt-chevron-right"></span>
                      </span>
                    </div>
                  </div>
                  <div className="packageInnerDetails false">
                    <div className="packageDetails">
                      <div className="topDetailsSection">
                        <div className="headingSection">
                          <div className="sortedByWrapper">
                            <div className="sortingSection">
                              <div className="sortingValueSection">
                                <span className="title">Sorted By: </span>
                                <span className="value">Popular</span>
                                <span className="icon mmt-chevron-down"></span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div style={{ height: '0px', width: '100%' }}></div>
                      <div className="packageCardList">
                      {this.state.packageData === null ? (
                    <>
                      <HotelListSkeleton />
                      <HotelListSkeleton />
                      <HotelListSkeleton />
                    </>
                  ) : this.state.packageData == "no_package"  || this.state.packageData.length === 0 ? (
                    <ExperiencesSoldout experienceurl={'?t=Mw=='}/>
                  ) : (
                    <>
                      {this.state.packageData.map((i, j) => {
                        if (i != "no_package") {
                         
                          return (
                        <section style={{ display: 'flex', maxWidth: '100%' }}>
                          <div className="packageCardWrapper similarPackage">
                            {/* <div className="similarPackTab">
                              <span>1 More Option Available</span>
                            </div> */}
                            <div className="imageCardWrapper">
                              {/* <span className="tagIcon mmtSign">
                                <img
                                  src={'https://hldak.mmtcdn.com/prod-s3-hld-hpcmsadmin/holidays/images/phonixImages/Best_Seller.png'}
                                  height="18px"
                                />
                              </span> */}
                              <div className="imageSlider">
                                <div className="slick-slider slick-initialized">
                                  <div className="slick-list">
                                    <div
                                      className="slick-track"
                                      style={{width: '414px', opacity: 1, transform: 'translate3d(0px, 0px, 0px)'}}
                                    >
                                      <div
                                        data-index="0"
                                        className="slick-slide slick-active slick-current"
                                        tabindex="-1"
                                        aria-hidden="false"
                                        style={{outline: 'none', width: '414px;'}}
                                      >
                                        <div>
                                          <div className="lazyload-wrapper">
                                            <div
                                              className="imageLoaderContainer "
                                              style={{
                                                width: '414px',
                                                height: '200px',
                                              }}
                                            >
                                              <img
                                                className=" active "
                                                width="414"
                                                height="200"
                                                src={'https://hldak.mmtcdn.com/prod-s3-hld-hpcmsadmin/holidays/images/cities/1328/Q.jpg'}
                                                alt="Package Image"
                                              />
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="packageTextContainer">
                              <div className="packageTopSection">
                                <div className="titleWrapper">
                                  <p
                                    title="Most Wanted Goa Package"
                                    className="packageHead"
                                  >
                                   {i?.package_name}
                                  </p>
                                  <span className="selected">{i?.no_days}N/{Number(i?.no_days || 0) + 1}D</span>
                                </div>
                                <div className="itineraryList">
                                {i?.location.map((loc, k) => {
                                  return(<span>{loc?.number}N {loc?.location}</span>);
                                })}
                                </div>
                                <ul className="tripListWrapper">
                                  <li>Round Trip Flights</li>
                                  <li>4 Star Hotel</li>
                                  <li>Airport Transfers</li>
                                  <li>Selected Meals</li>
                                </ul>
                                <ul className="visitListWrapper"></ul>
                              </div>
                              <div className="packageBottomSection">
                                <div className="includeWrapper">
                                  <div className="includeItemCard">
                                    <span className="leftSec">
                                      <span className="">Offer Price</span>
                                      <span className="bold packageOfftag">
                                        {" "}
                                        {i?.discount_percentage}% OFF
                                      </span>
                                    </span>
                                    <div className="rightSec">
                                      <p>
                                        <span className="priceStyle">
                                        €{i?.selling_price}
                                        </span>
                                        <span> </span>
                                      </p>
                                      <p>
                                        <span>Total Price</span>
                                        <span> €{i?.total_price}</span>
                                      </p>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </section>
                        );}})}
                        </>)}
                        {/* <section style={{ display: 'flex', maxWidth: '100%' }}>
                          <div className="packageCardWrapper similarPackage">
                            <div className="similarPackTab">
                              <span>1 More Option Available</span>
                            </div>
                            <div className="imageCardWrapper">
                              <div className="imageSlider">
                                <div className="slick-slider slick-initialized">
                                  <div className="slick-list">
                                    <div
                                      className="slick-track"
                                      style={{
                                        width: '414px',
                                        opacity: 1,
                                        transform: 'translate3d(0, 0, 0)',
                                      }}
                                    >
                                      <div
                                        data-index="0"
                                        className="slick-slide slick-active slick-current"
                                        tabindex="-1"
                                        aria-hidden="false"
                                        style={{
                                          outline: 'none',
                                          width: '414px',
                                        }}
                                      >
                                        <div>
                                          <div className="lazyload-wrapper ">
                                            <div
                                              className="imageLoaderContainer "
                                              style={{
                                                width: '414px',
                                                height: '200px',
                                              }}
                                            >
                                              <img
                                                className=" active "
                                                width="414"
                                                height="200"
                                                src={'https://hldak.mmtcdn.com/prod-s3-hld-hpcmsadmin/holidays/images/cities/1328/E.jpg'}
                                                alt="Package Image"
                                              />
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="packageTextContainer">
                              <div className="packageTopSection">
                                <div className="titleWrapper">
                                  <p
                                    title="Goa Bliss - Sea, Sand &amp; Serenity"
                                    className="packageHead"
                                  >
                                    Goa Bliss - Sea, Sand &amp; Serenity
                                  </p>
                                  <span className="selected">3N/4D</span>
                                </div>
                                <div className="itineraryList">
                                  <span>3N Goa</span>
                                </div>
                                <ul className="tripListWrapper">
                                  <li>Round Trip Flights</li>
                                  <li>4 Star Hotel</li>
                                  <li>Airport Transfers</li>
                                  <li>1 Activity</li>
                                  <li>Selected Meals</li>
                                </ul>
                                <ul className="visitListWrapper">
                                  <li style={{ color: 'rgb(0, 126, 125)' }}>
                                    <img
                                      className="highlight-icon"
                                      src={'https://hldak.mmtcdn.com/prod-s3-hld-hpcmsadmin/holidays/images/phonixImages/highlights_tick3x.png'}
                                      alt="Highlight Icon"
                                    />
                                    North Goa Sightseeing
                                  </li>
                                </ul>
                              </div>
                              <div className="packageBottomSection">
                                <div className="includeWrapper">
                                  <div className="includeItemCard">
                                    <span className="leftSec">
                                      <span className="">No Cost EMI at</span>
                                      <span className="bold">
                                        {" "}
                                        ₹9,984/month
                                      </span>
                                    </span>
                                    <div className="rightSec">
                                      <p>
                                        <span className="priceStyle">
                                          ₹40,301
                                        </span>
                                        <span> /Person</span>
                                      </p>
                                      <p>
                                        <span>Total Price</span>
                                        <span> ₹80,602</span>
                                      </p>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </section> */}
                      </div>
                      <div></div>
                    </div>
                  </div>
                </div>

                <div className="listingLhs " id="filter">
                  <div className="stickyHeaderLHS">
                    <h3>FILTERS</h3>
                  </div>
                  <div className="mbFilterHeader">
                    <h3>
                      <span className="icon mmt-cross"></span>Filter
                    </h3>
                    <span className="clearAllText">Clear All</span>
                  </div>
                  <div className="filterWrapper">
                    <div className="filtersOuter">
                      <div className="filterHeadouter">
                        <span className="filtersHead">
                          Duration (in Nights)
                        </span>
                        <span className="icon  mmt-chevron-up"></span>
                      </div>
                      <div className="innerListSection">
                        <div className="sliderfiltersOuter">
                          <div className="rangeSlider">
                            <div className="rc-slider">
                              <div className="rc-slider-rail"></div>
                              <div
                                className="rc-slider-track rc-slider-track-1"
                                style={{backgroundColor: 'rgb(0, 140, 255)', height: '6px', left: '0%', right: 'auto', width: '100%'}}
                              ></div>
                              <div className="rc-slider-step"></div>
                              <div
                                tabindex="0"
                                className="rc-slider-handle rc-slider-handle-1"
                                role="slider"
                                aria-valuemin="2"
                                aria-valuemax="7"
                                aria-valuenow="2"
                                aria-disabled="false"
                                style={{width: '24px', height: '24px', borderStyle: 'solid', borderWidth: '1px', borderColor: 'rgb(188, 188, 188)', borderRadius: '20px', marginTop: '-9px', boxShadow: 'none', left: '0%', right: 'auto', transform: 'translateX(-50%)'}}
                              ></div>
                              <div
                                tabindex="0"
                                className="rc-slider-handle rc-slider-handle-2"
                                role="slider"
                                aria-valuemin="2"
                                aria-valuemax="7"
                                aria-valuenow="7"
                                aria-disabled="false"
                                style={{width: '24px', height: '24px', borderStyle: 'solid', borderWidth: '1px', borderColor: 'rgb(188, 188, 188)', borderRadius: '20px', marginTop: '-9px', boxShadow: 'none', left: '0%', right: 'auto', transform: 'translateX(-50%)'}}
                              ></div>
                              <div className="rc-slider-mark"></div>
                            </div>
                          </div>
                          <div className="rangeValues">
                            <span>2N</span>
                            <span>7N</span>
                          </div>
                        </div>
                       
                      </div>
                    </div>
                    <div className="filtersOuter">
                      <div className="filterHeadouter">
                        <span className="filtersHead">Flights</span>
                        <span className="icon  mmt-chevron-down"></span>
                      </div>
                    </div>
                    <div className="filtersOuter">
                      <div className="filterHeadouter">
                        <span className="filtersHead">Budget (per person)</span>
                        <span className="icon  mmt-chevron-down"></span>
                      </div>
                    </div>
                    <div className="filtersOuter">
                      <div className="filterHeadouter">
                        <span className="filtersHead">Hotel Category</span>
                        <span className="icon  mmt-chevron-up"></span>
                      </div>
                      <div className="hotelCategorySection">
                        <span className="categoryRating  disabled">
                          <span>&lt;3★</span>
                          <span className="star-rating-count">(0)</span>
                        </span>
                        <span className="categoryRating  ">
                          <span>3★</span>
                          <span className="star-rating-count">(13)</span>
                        </span>
                        <span className="categoryRating  ">
                          <span>4★</span>
                          <span className="star-rating-count">(37)</span>
                        </span>
                        <span className="categoryRating  ">
                          <span>5★</span>
                          <span className="star-rating-count">(16)</span>
                        </span>
                      </div>
                    </div>
                    <div className="filtersOuter">
                      <div className="filterHeadouter">
                        <span className="filtersHead">Cities</span>
                        <span className="icon  mmt-chevron-down"></span>
                      </div>
                    </div>
                    <div className="filtersOuter">
                      <div className="filterHeadouter">
                        <span className="filtersHead">Themes</span>
                        <span className="icon  mmt-chevron-down"></span>
                      </div>
                    </div>
                    <div className="filtersOuter">
                      <div className="filterHeadouter">
                        <span className="filtersHead">Package Type</span>
                        <span className="icon  mmt-chevron-down"></span>
                      </div>
                    </div>
                    <div className="filtersOuter">
                      <div className="filterHeadouter">
                        <span className="filtersHead">Premium Packages</span>
                        <span className="icon  mmt-chevron-up"></span>
                      </div>
                      <div className="innerListSection">
                        <label className="filterListWrap  ">
                          <span className="customCheckbox">
                            <input type="checkbox" name="1" />
                            <span className="box">
                              <span className="check"></span>
                            </span>
                          </span>
                          <div className="filterListLeft">
                            <span className="filterText">Premium packages</span>
                          </div>
                          <span>(5)</span>
                        </label>
                      </div>
                    </div>
                  </div>
                  
                </div>
              </div>
            </div>
             {/* End Body Data */}

              </div>
              
             
          
      
    </div>
    <TawkToWidget />
    </React.Fragment>
  );
}
}
